'use client';

import React, { FC } from 'react';
import Comment from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/Comment';

interface CommentReply {
    databaseId: number;
    content?: string;
    replies?: {
        nodes: CommentReply[];
    };
    // Add other necessary fields
}

interface ReviewReplyProps {
    comment: CommentReply;
    all?: boolean;
}

const ReviewReply: FC<ReviewReplyProps> = ({ comment, all = false }) => {
    return (
        <div
            className={`mt-3 ms-4 p-3 rounded-xl ${
                all && comment?.replies?.nodes?.length && comment.replies.nodes.length > 0
                    ? ''
                    : 'bg-primary/5 dark:bg-white/10'
            } first:m-0 dark:border-r-white/30`}
        >
            <Comment comment={comment} />
            {all &&
                comment.replies &&
                comment.replies.nodes.length > 0 &&
                comment.replies.nodes.map((reply) => (
                    <ReviewReply comment={reply} all={all} key={reply.databaseId} />
                ))}
        </div>
    );
};

export default ReviewReply;
